import { Star, MessageCircle, Quote } from "lucide-react";
import { waLink } from "@/lib/site";

const testimonials = [
  {
    name: "Carlos M.",
    city: "Belém",
    text: "Meu carro parou no meio do caminho e o atendimento foi rápido. O reboque chegou, removeu o veículo com cuidado e resolveu meu problema.",
  },
  {
    name: "Ana Paula R.",
    city: "Ananindeua",
    text: "Precisei transportar minha moto e fui muito bem atendida pelo WhatsApp. Comunicação clara e serviço feito do jeito combinado.",
  },
  {
    name: "João V.",
    city: "Marituba",
    text: "Bateria descarregou de madrugada e a Brasil Transportes me ajudou com a recarga. Atendimento direto, sem enrolação.",
  },
];

export default function Testimonials() {
  return (
    <section id="depoimentos" className="bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Depoimentos</p>
        <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
          Quem chamou, recomenda
        </h2>
        <p className="mt-4 text-base md:text-lg text-neutral-400 max-w-2xl">
          A confiança de quem já precisou de guincho e contou com a Brasil Transportes.
        </p>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#171717] border border-white/10 rounded-md p-6 md:p-8 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-2 hover:border-[#FEFB0E]"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-1" aria-label="Avaliação 5 de 5 estrelas">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="w-5 h-5 fill-[#FEFB0E] text-[#FEFB0E]" />
                  ))}
                </div>
                <Quote className="w-8 h-8 text-[#50CF08]" />
              </div>
              <blockquote className="text-neutral-300 text-sm md:text-base leading-relaxed grow">
                “{t.text}”
              </blockquote>
              <figcaption className="border-t border-white/10 pt-4">
                <span className="block font-bold text-white">{t.name}</span>
                <span className="block text-sm text-neutral-500">{t.city} — PA</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="testimonials-whatsapp-btn"
          className="mt-10 inline-flex items-center gap-3 bg-[#50CF08] hover:bg-[#42B006] text-white font-extrabold uppercase px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
        >
          <MessageCircle className="w-5 h-5" />
          Precisa de reboque? Chame agora
        </a>
      </div>
    </section>
  );
}
